<template>
  <div>
    <div v-if="fetchState.pending">
      <div>loading...</div>
    </div>
    <div v-else-if="fetchState.error">
      <div>{{ $t('main.fetch-error') }}</div>
    </div>
    <div v-else v-html="agreementHtml" />
  </div>
</template>
<script>
import { defineComponent, ref, useContext, useFetch, useMeta } from '@nuxtjs/composition-api';
import pageHeader from '@/constants/pageHeaders';
import { IS_ONEDIO } from '~/constants/config';
export default defineComponent({
  head() {
    return pageHeader('agreement');
  },
  setup() {
    const { $service, $error, $cache } = useContext();
    $cache('public, max-age=60');
    useMeta(() => {
      if (IS_ONEDIO) return;
      return { meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }] };
    });
    const agreementHtml = ref();
    const { fetch, fetchState } = useFetch(async () => {
      try {
        const response = await $service.corporate.getUserAgreement();
        agreementHtml.value = response?.html;
      } catch (error) {
        $error(error);
      }
    });
    return { fetch, fetchState, agreementHtml };
  },
});
</script>
